import { pxToRem, themeGet, Drawer, Sidebar, CardContent } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const DropdownTriggerContainer = styled.button `
  display: flex;
  flex-direction: row;
  align-items: center;
  border: none;
  padding: 0;
  background: transparent;
  cursor: pointer;
`;
export const InfoContainer = styled.div `
  display: flex;
  flex-direction: column;
`;
export const StyledDrawer = styled(Drawer) `
  width: ${pxToRem(360)};
`;
export const StyledSidebar = styled(Sidebar) `
  width: 100%;
`;
export const CardContainer = styled.div `
  display: flex;
  flex-direction: column;
  padding: 0 ${themeGet('spacing.md')} ${themeGet('spacing.xl')};
  gap: ${themeGet('spacing.xl')};
`;
export const SignOutActionContainer = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const FlagAvatar = styled.div `
  height: ${pxToRem(21)};
  width: ${pxToRem(21)};
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  svg {
    path {
      height: ${pxToRem(28)};
    }
  }
`;
export const AvatarCardContent = styled(CardContent) `
  padding: ${themeGet('spacing.xl')};
  display: flex;
  flex-direction: column;
  gap: ${themeGet('spacing.2xl')};
`;
